import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { NAV, LOGO } from "@/lib/data";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 w-full z-50 border-b transition-colors duration-300 ${
        scrolled ? "bg-white/90 border-[#DCE1E8]" : "bg-white/70 border-transparent"
      } backdrop-blur-xl`}
    >
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 h-[74px] flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
          <img src={LOGO} alt="JM Mevada Pattern Works" className="h-12 w-12 object-contain" />
          <div className="leading-none hidden sm:block">
            <div className="font-display font-extrabold text-[15px] tracking-tight text-[#0E1626]">JM MEVADA</div>
            <div className="font-mono text-[9px] tracking-[0.22em] text-slate-500 uppercase">Pattern Works</div>
          </div>
        </Link>

        <nav className="hidden xl:flex items-center gap-7">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to === "/" ? "home" : n.to.slice(1)}`}
              className={`text-[13px] font-medium tracking-wide transition-colors duration-300 ${
                pathname === n.to ? "text-[#0E1626]" : "text-slate-500 hover:text-[#0E1626]"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate("/enquiry")}
            data-testid="header-request-quote"
            className="btn-primary hidden sm:inline-flex !py-3 !px-5 !text-[11px]"
          >
            Request A Quote <ArrowUpRight size={15} />
          </button>
          <button
            className="xl:hidden text-[#0E1626]"
            onClick={() => setOpen((o) => !o)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="xl:hidden bg-white border-t border-[#DCE1E8]" data-testid="mobile-menu">
          <div className="px-5 py-6 flex flex-col gap-1">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                className={`py-3 text-lg font-display font-bold uppercase tracking-tight border-b border-[#EAEEF3] ${
                  pathname === n.to ? "text-[#1D4ED8]" : "text-[#0E1626]"
                }`}
              >
                {n.label}
              </Link>
            ))}
            <button onClick={() => navigate("/enquiry")} className="btn-primary mt-4 justify-center">
              Request A Quote <ArrowUpRight size={16} />
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
